import { Row } from 'antd'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { ToolBox } from 'app/lib/hooks/toolBox'
import * as React from 'react'

type InfoProps = {
  icon?: React.ReactNode
  attribute: string
  value: React.ReactNode
  recordType: string
}

const KInfoRow: React.FC<InfoProps> = ({ icon, attribute, value, recordType }) => {
  const { tAttribute } = ToolBox.useString()
  return (
    <Row gutter={[24, 0]} align="middle" wrap={false}>
      <KCol flex="none" render={Boolean(icon)}>
        {icon}
      </KCol>
      <KCol flex="auto">
        <span className="text-primary mb-1 d-block">{tAttribute({ recordType, attribute })}</span>
        <span className="mb-1 d-block">{value || '-'}</span>
      </KCol>
    </Row>
  )
}

export default KInfoRow
